import { Store } from "@/store/store";
import LabelService from "../LabelService";
import errorManager from "@/modules/errors/error-services/error-manager";
import ThingService from "@/modules/thing/ThingService";
class GroupStore extends Store {
  data() {
    return {
      label: "",
      imei: [],
      allLabels: [],
    };
  }
  clear() {
    console.log("clear?");
    this.state.label = "";
    this.imei = [];
    console.log(this.state.label);
  }
  getImeis() {
    console.log(this.imei);
    if (this.imei) {
      return this.imei;
    } else if (this.state.label && this.state.label.length>0) {
        this.getImeiByLabel(this.state.label);
        return this.imei;
      } else {
        return [];
      }
    
  }
  
async getImeiByLabel(value) {
  console.log("v:" + value + ".");
  if (!value) {
    this.imei = [];
    return;
  }

  await LabelService.getImeiByLabel(value)
    .then(({ data }) => {
      return Promise.all(data.map(async (imei) => {

          return ThingService.getThingFiltered(imei)
          .then((resp) => {
            const content = resp.data.content;
            const def = content?.[0]?.definition || "Thing not found";
            return { label: `${imei} - ${def}`, value: imei };
          })
          .catch((err) => {
            console.warn(`Failed to fetch definition for ${imei}`, err);
            return { label: `${imei}-Error`, value: imei };
          });
        }))
      
    })
    .then((imeiDefs) => {
      this.imei = imeiDefs;
      console.log("Resolved IMEI definitions:", this.imei);
    })
    .catch((error) => {
      console.error("Error fetching IMEI by label:", error);
      errorManager.manage(error, () => (this.imei = []));
    });
}

  async updateAllLabels() {
    return LabelService.getAllLabels().then(
      ({ data }) => {
        this.state.allLabels = data;
        return this.allLabels;
      },
      (error) => {
        //do nothing
        errorManager.manage(
          error,
          errorManager.defaultCase(() => null),
          errorManager.caseNotFound(() => (this.state.allLabels = []))
        );
        return this.state.allLabels;
      }
    );
  }
  //TODO consider how to rewrite the nested promises
  async removeImei(imei) {
    //retrive labela first
    return LabelService.getLabelsByImei(imei)
      .then(({ data }) => {

        let labels = data.accessLabels;
        //investigate why there was a space
        console.log("l:." + this.state.label);
        labels = labels.filter((e) => e != this.state.label);

        console.log("nest1", labels);
        return LabelService.updateLabelsToImei(imei, labels).then(
          ({ data }) => {
            this.imei = this.imei.filter((i) => i.value != imei);
            console.log("nest2");

            return Promise.resolve(data);
          },
          (error) => {
            //push error and return reject
            return errorManager.manage(
              error,
              errorManager.deafaultReject(error)
            );
          }
        );
      })
      .catch((error) => {
        return errorManager.manage(error, () => null);
      });
    /*get imei's labels add rquested and post */
  }
  async addImei(imei) {
    //retrive labela first
    let labels = await LabelService.getLabelsByImei(imei).then(
      ({ data }) => {
        let labels = [];
        if (data.accessLabels) {
          labels = data.accessLabels;
        }
        console.log(labels);
        if (this.state.label) {
          labels.push(this.state.label);
        }
        console.log(labels);
        console.log("nest1");
        return Promise.resolve(labels);
      },
      (error) => {
        return errorManager.manage(
          error,
          errorManager.caseNotFound(() => {
            let labels = [];
            if (this.state.label) {
              labels.push(this.state.label);
            }
            console.log("nest1", labels);
            return Promise.resolve(labels);
          }, errorManager.defaultCase(errorManager.deafaultReject(error)))
        );
      }
    );
    //build updated label list
    return LabelService.updateLabelsToImei(imei, labels).then(
      ({ data }) => {
        console.log("nest2.2", data);
        const findimei = this.imei.findLast((i) => i.value == imei);
        if (!findimei) {
          this.imei = this.imei.concat([{ label: imei, value: imei }]);
        }
        return Promise.resolve(data);
      },
      (error) => {
        console.log(error);
        return errorManager.manage(error, errorManager.deafaultReject(error));
      }
    );

    /*get imei's labels add rquested and post */
  }
}

export const groupStore = new GroupStore("GROUP");
export function useGroupStore() {
  return this.groupStore;
}
